module.exports = __webpack_public_path__ + "static/media/food_placeholder.f9d95c2d.jpg";